import React from "react";

import { IDotOption } from "../RadioButtons.types";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import cx from "apps/website/utils/misc/cx";

const DotOption = React.forwardRef<HTMLDivElement, IDotOption>((props, ref) => (
  <div
    data-component={props.component ?? DotOption.name}
    data-value={props.value}
    aria-disabled={props.disabled}
    className="w-full flex space-x-2 items-center"
    ref={ref}
  >
    <div
      data-testid="DotOption__dot"
      className={cx(
        "rounded-full border border-solid border-black w-3 h-3",
        props.selected ? "bg-black ring-1 ring-black ring-offset-2" : null,
      )}
    ></div>
    <TextBody
      data-testid="DotOption__label"
      size={4}
    >
      { props.label }
    </TextBody>
  </div>
));

DotOption.displayName = "DotOption";

export default DotOption;
